import formsConfigs from '../../../store/forms/formsConfigs/formsConfigs';
import FORMS from '../../../store/forms/formsConfigs/constants';

const registrarUserForm = formsConfigs.getById(FORMS.REGISTRAR_USER);
const signSmsForm = formsConfigs.getById(FORMS.SIGN_SMS);
const registrarUserOrgForm = formsConfigs.getById(FORMS.REGISTRAR_USER_ORG);
const registrarUserOrgResultForm = formsConfigs.getById(
  FORMS.REGISTRAR_USER_ORG_RESULT
);
const passwordForm = formsConfigs.getById(FORMS.PASSWORD);

const steps = [
  {
    step: 1,
    label: 'Контакты'
  },
  {
    step: 2,
    label: 'Организация'
  },
  {
    step: 3,
    label: 'Пароль'
  }
];

const stepsForms = {
  stepOne: {
    id: registrarUserForm.instanceName,
    step: 1
  },
  stepOneSms: {
    id: signSmsForm.instanceName,
    step: 1
  },
  stepTwo: {
    id: registrarUserOrgForm.instanceName,
    step: 2
  },
  stepTwoResult: {
    id: registrarUserOrgResultForm.instanceName,
    step: 2
  },
  stepThreeForm: {
    id: passwordForm.instanceName,
    step: 3
  }
};

const getFormsArray = () => Object.keys(stepsForms).map(key => stepsForms[key]);
const getFormById = id => getFormsArray().find(step => step.id === id);
const getFormStepById = id => {
  const form = getFormById(id);

  return form.step;
};

const registerFormsIds = getFormsArray().map(step => step.id);

export { steps, registerFormsIds, getFormStepById };



// WEBPACK FOOTER //
// ./src/components/containers/NewClient/config.js